import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { Field, formValueSelector, change, FormSection } from 'redux-form';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';

import InputField from '../../form/InputField';
import ListSelectEditorField from './ListSelectEditorField';

const ListSelectFormSelector = (state, props) => {
  const selector = formValueSelector(props.uid || props.form);
  return selector(state, 'typeOptions', 'propValue');
};

const ListSelectDesignerSelector = createSelector(
  [ListSelectFormSelector],
  (listSelectForm) => ({
    fields: listSelectForm,
  })
);

@connect(ListSelectDesignerSelector)
export default class ListSelectDesigner extends PureComponent {
  static propTypes = {
    containerClassName: PropTypes.string,
    containerStyle: PropTypes.object,
    dispatch: PropTypes.func,
    fields: PropTypes.object,
    input: PropTypes.object,
    multi: PropTypes.bool,
    labelClassName: PropTypes.string,
    listSelectOptions: PropTypes.array,
    uid: PropTypes.string,
    value: PropTypes.string,
    wrapperClassName: PropTypes.string,
    wrapperStyle: PropTypes.object,
  };

  setListOptions = value => value && value.split(/\r?\n/);

  listOutput = (value) => {
    if (value && Array.isArray(value)) {
      return value.join('\n');
    }
    return value;
  }

  handleDesignerOnChange = (value) => {
    const {
      uid,
      dispatch,
      fields: { typeOptions, propValue },
    } = this.props;

    dispatch(change(uid, 'typeOptions.options', this.setListOptions(value)));

    if (
      typeOptions &&
      typeOptions.options &&
      Array.isArray(typeOptions.options) &&
      typeOptions.options.length >= 1 &&
      !propValue
    ) {
      const firstOption = typeOptions.options[0];
      dispatch(change(uid, 'propValue', firstOption));
    }
  }

  render() {
    const {
      containerClassName,
      containerStyle,
      dispatch,
      fields: { typeOptions },
      input,
      labelClassName,
      multi,
      wrapperClassName,
      wrapperStyle,
      uid,
    } = this.props;

    const designer = (
      <div className={wrapperClassName} style={wrapperStyle}>
        <label className={labelClassName}>List Options</label>
        <div className={containerClassName} style={containerStyle}>
          <FormSection name="typeOptions">
            <Field
              className="form-control"
              component={InputField}
              format={this.listOutput}
              name="options"
              normalize={this.setListOptions}
              onChange={e => {
                this.handleDesignerOnChange(e.target.value);
              }}
              style={{ width: '100%', marginBottom: 10 }}
              type="textarea"
            />
          </FormSection>
        </div>
      </div>
    );

    return (
      <div>
        {designer}
        <div className={wrapperClassName} style={wrapperStyle}>
          <label className={labelClassName}>Default Value</label>
          <div className={containerClassName} style={containerStyle}>
            <ListSelectEditorField
              dispatch={dispatch}
              input={input}
              multi={multi}
              typeOptions={typeOptions}
              uid={uid}
            />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/types/ListSelect/ListSelectDesigner.js